module.exports = __webpack_public_path__ + "static/img/mb-03.fd10a83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w11/mb-03.jpg
// module id = srUF
// module chunks = 1